<template>
  <div class="home home-box">
	  <audio id="blessingAudio" :src="audioSrc"></audio>
	 <div class="background-content">
		 <img class="background-content-top-logo" src="../assets/images/fm-logo.png" alt="">
		 <img class="background-content-left-img" src="../assets/images/left-logo.png" alt="">
		 <div class="background-content-background-box">
			 <img class="background-content-background-box-shadingImg" src="../assets/images/shading-img.png" alt="">
		 </div>
		 
	 </div>
	 <div class="begin-box content-box" v-if="showBeginBox">
		 <img class="content-box-topImg" src="../assets/images/top-logo.png" alt="">
		 <p class="begin-box-top">当你看清这些字的时候说明你已经得到了这个世界上最最最最最最美好的祝福了</p>
		 <div class="begin-box-middle">
			 <img class="begin-box-middle-background" src="../assets/images/home-begin-box.png" alt="" >
			 <img class="begin-box-middle-btn" src="../assets/images/home-begin-btn.png" alt="" @click="clickBeginGameBtn">
		 </div>
		 <p class="begin-box-text" @click="clickMyCollect">我的祝福卡集</p>
		 <div class="begin-box-bottom">
			 <!-- <img class="begin-box-bottom-ruleBackground" src="../assets/images/rule-box.png" alt=""> -->
			 <img class="begin-box-bottom-ruleBackground" src="../assets/images/new-rule-box.png" alt="">
			 <div class="begin-box-bottom-ruleBox">
				 <p class="begin-box-bottom-ruleBox-text">1、活动时间：2021年2月10日9:00至2月16日23:59:59</p>
				 <p class="begin-box-bottom-ruleBox-text">2、盲盒介绍：封面新闻携手新年祝福官为您送上新年祝福，所有语音祝福已打包进盲盒，快来扭开，看看您收到了谁的祝福，发现隐藏盲盒还将获得惊喜礼品一份！</p>
				 <p class="begin-box-bottom-ruleBox-text">3、盲盒规则：① 封面新闻APP的每位用户每天可扭三次盲盒，分享可增加一次机会（每日仅限一次）。② 若发现隐藏盲盒，还可获得惊喜礼品一份。③ 点击“我的祝福卡集”可查看所有已抽中的祝福。</p>
			 </div>
			 <p class="begin-box-bottom-tips">公益支持单位：中国东方航空、地标马克</p>
		 </div>
		 
	 </div>
	 
	 <div class="game-box content-box" v-if="showGameBox">
		 <img class="content-box-topImg" src="../assets/images/top-logo.png" alt="">
		 <img class="content-box-backImg" src="../assets/images/top-back-btn.png" alt="" @click="gamePageBackBtnClick">
		 
		 <img class="game-box-bear" src="../assets/images/shading-bear-logo.png" alt="">
		 <div class="game-box-info">
			<img class="game-box-info-img" id="shakingImg" :src="require('../assets/images/game/top-'+gameItemChooseIndex+'.png')" alt="">
			<img class="game-box-info-shadow" src="../assets/images/game-box-shadow.png" alt="">
		 </div>
		 <div class="game-box-function">
			 <img class="game-box-function-leftArrow game-box-function-arrow" src="../assets/images/game-left-arrow.png" @click="gameArrowClick(1)" alt="">
			 <div class="game-box-function-box">
				 <div class="game-box-function-box-item" v-for="(item,index) in gameImgs">
					 <img :class="['game-box-function-box-item-img',gameItemChooseIndex==index+1 ? 'game-box-function-box-item-choose' : '']" :src="require('../assets/images/game/bottom-'+item)" alt="'../assets/images/game/bottom-'+item" @click="cardItemSelect(index)">
					 <img class="game-box-function-box-item-topArrow" v-if="gameItemChooseIndex==index+1" src="../assets/images/game-top-arrow.png" alt="">
				 </div>
			 </div>
			 <img class="game-box-function-rightArrow game-box-function-arrow" src="../assets/images/game-right-arrow.png" @click="gameArrowClick(2)" alt="">
		 </div>
		 <div class="game-box-bottom bottom-function-box">
			 <img class="game-box-bottom-img bottom-function-box-img" src="../assets/images/game-bottom-background.png" alt="">
			 <div class="game-box-bottom-btn bottom-function-box-btn" @click="clickGameBeginBtn">
				 <img class="game-box-bottom-btn-img bottom-function-box-btn-img" src="../assets/images/game-begin-btn.png" alt="">
				 <p class="game-box-bottom-btn-tips bottom-function-box-btn-tips">(剩余{{gameTotalCount}}次机会)</p>
			 </div>
		 </div>
	 </div>
	 
	 <div class="result-box content-box" v-if="showResultBox">
		 <img class="content-box-topImg" src="../assets/images/top-logo.png" alt="">
		 <img class="content-box-backImg" src="../assets/images/top-back-btn.png" alt="" @click="resultPageBackBtnClick">
		 <div class="result-success-box" v-if="winning">
			 <div class="result-success-box-info">
				 <div class="result-success-box-info-photoBox">
					 <img class="result-success-box-info-photoBox-bear" src="../assets/images/shading-bear-logo.png" alt="">
					 <img class="result-success-box-info-photoBox-info" src="../assets/images/winning-prize-logo.png" alt="">
				 </div>
				 <div class="result-success-box-info-functionBar">
					 <img class="result-success-box-info-functionBar-btn" src="../assets/images/result-bless-btn.png" alt="" @click="clickBlessBtn">
					 <img class="result-success-box-info-functionBar-btn" src="../assets/images/result-poster-btn.png" alt="" @click="clickPosterBtn">
				 </div>
			 </div>
			 <div class="bottom-function-box">
				 <img class="bottom-function-box-img" src="../assets/images/game-bottom-background.png" alt="">
				 <div class="bottom-function-box-btn">
					 <img class="bottom-function-box-btn-resultImg" src="../assets/images/get-prize-btn.png" alt="" @click="clickreceiveRewardBtn">
				 </div>
			 </div>
			 <div class="toast-box" v-if="showToast">
				 <div class="toast-box-info">
					<div class="toast-box-info-subInfo">
						<div class="toast-box-info-subInfo-content" v-if="!received && !receiveSuccess">
							<p class="toast-box-info-subInfo-content-title" >礼品名称：{{prizeInfo.name}}</p>
							<p class="toast-box-info-subInfo-content-desc" >礼品详情：礼品内容及使用规则，请点击首页右上角头像，进入个人中心-消息中心-通知内查看。  </p>
							<p class="toast-box-info-subInfo-content-desc" >注意：下方信息为礼品寄送信息，提交后不可更改，请谨慎填写，未填写或填写错误，将无法收到礼品。礼品将于2021年2月22日至26日内寄出，如有问题请联系028-86969058（工作日9:00-18:00）。</p>
							<p class="toast-box-info-subInfo-content-title">寄送信息：</p>
							<form>
								<div class="toast-box-info-subInfo-content-item">
									<p>姓名：</p>
									<input type="text" placeholder="请填写真实姓名" v-model="formData.name">
								</div>
								<div class="toast-box-info-subInfo-content-item">
									<p>电话：</p>
									<input type="number" pattern="number" onkeyup="value=value.replace(/[^\d\.]/g,'')" placeholder="请填写有效的11位电话号码" v-model="formData.phone">
								</div>
								<div class="toast-box-info-subInfo-content-item">
									<p>地址：</p>
									<!-- <input type="text" placeholder=""> -->
									<textarea name="" id="" rows="2" placeholder="请填写真实的收件地址: 省市区街道门牌号" v-model="formData.address"></textarea>
								</div>
							</form>
							<img class="toast-box-info-subInfo-content-submitBtn" src="../assets/images/submit-btn.png" alt="" @click="submitUserinfo">
						</div>
						<div class="toast-box-info-subInfo-content" v-if="receiveSuccess">
							<img class="toast-box-info-subInfo-content-receiveSuccessLogo" src="../assets/images/success-logo.png" alt="">
							<p class="toast-box-info-subInfo-content-desc toast-box-info-subInfo-content-receiveTitle" >礼品已领取！</p>
							<p class="toast-box-info-subInfo-content-desc toast-box-info-subInfo-content-receiveDesc" >我们将在2021年2月22日至2月26日内致电您确认信息，您也可在活动首页“我的祝福卡集”内，点击隐藏盲盒查看信息。</p>
						</div>
						<div class="toast-box-info-subInfo-content" v-if="received && !receiveSuccess">
							<img class="toast-box-info-subInfo-content-receiveSuccessLogo" src="../assets/images/success-logo.png" alt="">
							<p class="toast-box-info-subInfo-content-desc toast-box-info-subInfo-content-receiveTitle" >礼品已领取！</p>
							<p class="toast-box-info-subInfo-content-title toast-box-info-subInfo-content-receiveInfoTitle" >领取时间：</p>
							<p class="toast-box-info-subInfo-content-desc toast-box-info-subInfo-content-receiveInfo" >{{applyInfo.applyTime}}</p>
							<p class="toast-box-info-subInfo-content-title toast-box-info-subInfo-content-receiveInfoTitle" >礼品名称：</p>
							<p class="toast-box-info-subInfo-content-desc toast-box-info-subInfo-content-receiveInfo" >{{prizeInfo.name}}</p>
							<p class="toast-box-info-subInfo-content-title toast-box-info-subInfo-content-receiveInfoTitle" >礼品详情：</p>
							<p class="toast-box-info-subInfo-content-desc toast-box-info-subInfo-content-receiveInfo" >礼品内容及使用规则，请点击首页右上角头像，进入个人中心-消息中心-通知内查看。</p>
							<p class="toast-box-info-subInfo-content-title toast-box-info-subInfo-content-receiveInfoTitle" >寄送信息：</p>
							<p class="toast-box-info-subInfo-content-desc toast-box-info-subInfo-content-receiveInfo" >姓名：{{applyInfo.info.name}}</p>
							<p class="toast-box-info-subInfo-content-desc toast-box-info-subInfo-content-receiveInfo" >电话：{{applyInfo.info.phone}}</p>
							<p class="toast-box-info-subInfo-content-desc toast-box-info-subInfo-content-receiveInfo" >地址：{{applyInfo.info.address}}</p>
							<p class="toast-box-info-subInfo-content-desc toast-box-info-subInfo-content-receiveInfo" >注意：礼品将于2021年2月22日至26日内寄出，如有问题请联系028-86969058（工作日9:00-18:00）。</p>
						</div>
					</div>
					<div class="toast-box-info-topBar">
						<p class="toast-box-info-topBar-title">领取详情</p>
						<img class="toast-box-info-topBar-clooseBtn" src="../assets/images/tips-cloose-btn.png" alt="" @click="closeToast">
					</div>
				 </div>
			 </div>
		 </div>
		 
		 <div class="result-fail-box" v-if="!winning">
			 <div class="result-fail-box-info">
				 <div class="result-fail-box-info-photoBox">
					 <img class="result-fail-box-info-photoBox-info" :src="require('../assets/images/starPoster/'+selectStar.image+'.jpg')" alt="">
					 <img class="result-fail-box-info-photoBox-border" src="../assets/images/photo-border.png" alt="">
					 <img class="result-fail-box-info-photoBox-status" src="../assets/images/pause-state-logo.png" alt="">
				 </div>
				 <div class="result-fail-box-info-functionBar">
					 <img class="result-fail-box-info-functionBar-btn" src="../assets/images/result-bless-btn.png" alt="" @click="clickBlessBtn">
					 <img class="result-fail-box-info-functionBar-btn" src="../assets/images/result-share-btn.png" alt="" @click="clickShareBtn">
					 <img class="result-fail-box-info-functionBar-btn" src="../assets/images/result-poster-btn.png" alt="" @click="clickPosterBtn">
				 </div>
				 <p class="result-fail-box-info-tips">2021，“牛”转乾坤，再扭一个</p>
				 <p class="result-fail-box-info-tips">发现隐藏盲盒，还将获得精美礼品一份</p>
			 </div>
			 <div class="bottom-function-box">
				 <img class="bottom-function-box-img" src="../assets/images/game-bottom-background.png" alt="">
				 <div class="bottom-function-box-btn">
					 <img class="bottom-function-box-btn-resultImg" src="../assets/images/play-again-btn.png" alt="" v-if="!winning" @click="clickPlayAgainBtn">
					 <img class="bottom-function-box-btn-resultImg" src="../assets/images/get-prize-btn.png" alt="" v-if="winning">
				 </div>
			 </div>
		 </div>
	 </div>
  
	 <div class="collect-box content-box" v-if="showCollectBox">
		 <img class="content-box-topImg" src="../assets/images/top-logo.png" alt="">
		 <div class="collect-box-info">
			 <p class="collect-box-info-tips">提示：显示为待收集的卡片，均为尚未抽中的祝福。 抽中后，小卡片将点亮哦。</p>
			 <div class="collect-box-info-cardBox">
				 <div :class="['collect-box-info-cardBox-item', index % 4 == 0 ? 'collect-box-info-cardBox-itemLast' : '']" v-for="(item,index) in collectCards" @click="showPrizePage(false,item)">
					 <div class="collect-box-info-cardBox-item-top">
						 <img class="collect-box-info-cardBox-item-top-photoInfo" v-if="item.name" :src="require('../assets/images/starPoster/'+item.image+'.jpg')" alt="">
						 <img class="collect-box-info-cardBox-item-top-photoBorder" v-if="item.name" src="../assets/images/photo-border.png" alt="">
					 </div>
					 <p class="collect-box-info-cardBox-item-name">{{item.name ? item.name : "待收集"}}</p>
				 </div>
			 </div>
			 <div class="collect-box-info-hiddenTips">
				 <p class="collect-box-info-hiddenTips-title">隐藏盲盒</p>
				 <p class="collect-box-info-hiddenTips-line"></p>
			 </div>
			 <div class="collect-box-info-hiddenNoSource" v-if="!haveHiddenBox"></div>
			 <img class="collect-box-info-hiddenInfo" src="../assets/images/hidden-prize-logo.png" alt="" v-if="haveHiddenBox"  @click="showPrizePage(true,{})">
			 <img class="collect-box-info-backBtn" src="../assets/images/bottom-back-btn.png" alt="" @click="collectBackBtnclick">
		 </div>
	 </div>
  
	 <div class="shareIn-box content-box" v-if="showShareInBox">
		 <img class="content-box-topImg" src="../assets/images/top-logo.png" alt="">
		 <div class="shareIn-box-info">
			 <div class="shareIn-box-info-haveInfo">
				 <div class="shareIn-box-info-haveInfo-infomation" v-if="selectStar">
					 <img class="shareIn-box-info-haveInfo-infomation-useravatar" :src="require('../assets/images/starPoster/'+selectStar.image+'.jpg')" alt="">
					 <img class="shareIn-box-info-haveInfo-infomation-photoBorder" src="../assets/images/photo-border.png" alt="">
				 </div>
				 <img class="shareIn-box-info-haveInfo-defultImg" v-if="!selectStar" src="../assets/images/shareIn-defult-logo.png" alt="">
			 </div>
			 
			 <img class="shareIn-box-info-functionBtn" src="../assets/images/shareIn-play-btn.png" alt="" @click="clickBlessBtn">
			 <p class="shareIn-box-info-tips" style="margin-top: 5.93vw;">快来抽取属于你的专属祝福。</p>
			 <p class="shareIn-box-info-tips" style="margin-top: 1.85vw;">发现隐藏盲盒，还将获得惊喜礼品赠送！</p>
			 <img class="shareIn-box-info-functionBtn" src="../assets/images/shareIn-begin-btn.png" alt="" @click="shareInBeginClick">
			 <!-- <img class="shareIn-box-info-backBtn" src="../assets/images/bottom-back-btn.png" alt="" @click="shareInPageBackBtnClick"> -->
		 </div>
	 </div>
  
	<div class="poster-box" v-if="showPosterBox">
		<div class="poster-info">
			<img class="poster-img" :src="posterImg" alt="" @click="posterImgClick">
			<p class="save-tips-text">点击图片进行分享</p>
			<img class="dismiss-poster-btn" src="../assets/images/poster-cancle-btn.png" alt="" @click="dismissPosterMask">
		</div>
	</div>
  
	<div
	  class="activity-download-pop"
	  v-if="!isApp && showDownLoadPop"
	>
	  <div class="activity-download-pop-inner">
	    <p>参加该活动需在封面新闻APP中进行</p>
	    <span @click="downLoadApp">确认</span>
	  </div>
	</div>
	
  </div>
</template>

<script>
import CONFIG from "@/utils/config";
import COVERAPP from "@/utils/COVERAPP";
import COVER from "@/utils/COVER";
import { mapState, mapActions } from "vuex";

export default {
  name: "home",
  data() {
    return {
		audioSrc: '',
		formData: {
			name: '',
			phone: '',
			address: ''
		},
		showBeginBox: true,
		showGameBox: false,
		showResultBox: false,
		showCollectBox: false,
		showShareInBox: false,
		showPosterBox: false,
		showDownLoadPop: false,
		posterImg: "",
		prizeInfo: {},
		winning: false,
		received: false,
		receiveSuccess: false,
		showToast: false,
		shareInHaveInfo: false,
		onNetworking: false,
		haveDataSource: false,
		isFromCollect: false,
		gameTotalCount: 0,
		gameItemChooseIndex: 1,
		luckOrigin: 'open',
		collectCards: [],
		collectStarType: [1,2,3,4,5,6],
		haveHiddenBox: false,
		selectStar: null,
		applyInfo: {},
		gameImgs: ['1.png','2.png','3.png','4.png','5.png'],
		starInfo: [
			{
				name: "丁真",
				image: 'dz',
				audio: 'https://yunyingcdn.thecover.cn/o_1eu2oi9u19721v04dka1ivg1fpsf.mp3',
				starType: 1
			},
			{
				name: "李佳琦",
				image: 'ljq',
				audio: 'https://yunyingcdn.thecover.cn/o_1eu2oi9u11jti3be1hnu16u3qocg.mp3',
				starType: 2
			},
			{
				name: "李易峰",
				image: 'lyf',
				audio: 'https://yunyingcdn.thecover.cn/o_1eu2oi9u11p7kvqt18isl711lude.mp3',
				starType: 3,
			},
			{
				name: "马东",
				image: 'md',
				audio: 'https://yunyingcdn.thecover.cn/o_1eu2oi9u11h5aa50dng1p5hqj6h.mp3',
				starType: 4
			},
			{
				name: "陶勇",
				image: 'ty',
				audio: 'https://yunyingcdn.thecover.cn/o_1eu2oi9u11ln97f4a901baq1f2qj.mp3',
				starType: 5
			},
			{
				name: "田亮",
				image: 'tl',
				audio: 'https://yunyingcdn.thecover.cn/o_1eu3dlsgb1hqp1osc1qveet19so9.mp3',
				starType: 6
			}
		]
	};
  },
  computed: {
    ...mapState(["shareData", "isApp", "aid", "activityData", "userinfo", "isPlayAudio"]),
  },
  created() {
	  if (this.getQueryVariable('starType')) {
		  var starType = this.getQueryVariable('starType').starType;
		  var starTypeNum = starType.substr(0,1);
		  this.showBeginBox = false;
		  this.isFromCollect = false;
		  this.selectStar = this.starInfo[Number(starTypeNum) - 1] 
		  this.showShareInBox = true;
	  }
	  // if (!localStorage.getItem(shareRequested)) {
	  // 	localStorage.setItem('shareRequested', false);
	  // }
  },
  mounted() {
    const _this = this;
    this.share();
    document.querySelector(".loading-wrap").style.display = "none";
    this.setPageLoadingAsync(false);
	this.getLotteryCount('open');
	this.getPrizeList();
  },
  methods: {
    ...mapActions(["setPageLoadingAsync","Toast",'getUserinfoAsync','setUserinfo']),
    share() {
      COVER.share(this.shareData);
    },
	//下载APP
	downLoadApp() {
	  const openApp = this.activityData.openApp || {};
	  COVER.downloadApp(this.aid, openApp.flag, openApp.news_id);
	},
	getQueryVariable() {
		var str, parastr;
		var array = {};
		str = window.location.href;
		parastr = str.split("?")[1];
		if (!parastr) {
			return null
		}
		var arr = parastr.split("&");
		for (var i = 0; i < arr.length; i++) {
			array[arr[i].split("=")[0]] = arr[i].split("=")[1];
		}
		return array;
	},
	getLotteryCount(originInfo) {//获取抽奖剩余次数
		var gameCount =  sessionStorage.getItem('gameCount');
		if (gameCount > 0) {
			this.gameTotalCount = gameCount
		} else{
			COVER.post('/lottery/query/count',{
				aid: this.aid,
				userinfo: this.userinfo,
				origin: originInfo
			}).then(res => {
				if (res.errno == 0 || res.errno == 2003 || res.errno == 2004) {
					if (originInfo === 'share') {
						if (res.data && res.data.luckDayTotal === 3) {
							this.luckOrigin = 'share';
							this.gameTotalCount = 1;
							sessionStorage.setItem('gameCount',1);
						}
					} else {
						if (res.data) {
							this.luckOrigin = 'open';
							this.gameTotalCount = 3 - res.data.luckDayTotal;
							sessionStorage.setItem('gameCount',3 - res.data.luckDayTotal);
							// localStorage.setItem('shareRequested', false);
						}
					}
					
				}else if (res.errno == 2015 && originInfo === 'open') {
					this.gameTotalCount = 0;
					this.getLotteryCount('share');
				} else {
					this.gameTotalCount = 0;
					sessionStorage.setItem('gameCount',0);
				}
				
			})
		}
	},
	getPrizeList() {//获取抽奖信息
		var that = this;
		COVER.post('/lottery/prize/list',{
			aid: this.aid,
			userinfo: this.userinfo,
		}).then(res => {
			if (Number(res.errno) == 0) {
				if (res.data.list) {
					var prizeList = res.data.list;
					var winList = false;
					var starList = [];
					// var collect = that.collectStarType;
					for (let prize of prizeList) {
						if (prize.type === 'none') {
							console.log(starList.indexOf(prize));
							var havePrize = false;
							starList.forEach(item=>{
								if (item.info.starType === prize.info.starType) {
									havePrize = true;
								}
							})
							if (!havePrize) {
								starList.push(prize)
							}
							// if (starList.indexOf(prize) == -1) {
							// 	starList.push(prize);
							// }
							// starList.push(prize);
							
							// // 用于后面点击上传的判重
							// if (collect.indexOf(prize.info.starType) > -1) {
							// 	collect.splice(collect.indexOf(prize.info.starType),1)
							// }
						} else{
							winList = true
							that.prizeInfo = prize;
						}
					}
					var newStarList = []
					for (var i = 0; i < 6; i++) {
						if (starList[i]) {
							newStarList.push(that.starInfo[starList[i].info.starType-1])
						} else{
							newStarList.push({})
						}
					}
					that.collectCards = newStarList;
					// that.collectStarType = collect;
					that.haveHiddenBox = winList;
				}
				
			} else {
				var newStarList = []
				for (var i = 0; i < 6; i++) {
					newStarList.push({})
				}
				this.collectCards = newStarList;
			}
		})
	},
	randomNum(minNum,maxNum){ //生成从minNum到maxNum的随机数
	    switch(arguments.length){ 
	        case 1: 
	            return parseInt(Math.random()*minNum+1,10); 
	        break; 
	        case 2: 
	            return parseInt(Math.random()*(maxNum-minNum+1)+minNum,10); 
	        break; 
	            default: 
	                return 0; 
	            break; 
	    } 
	},
	elShaking(el) {
		const maxAngle = 7 // 震动偏移角度
		const interval = 12 // 震动快慢，数字越小越快，太小DOM反应不过来，看不出动画
		const quarterCycle = 6 // 一次完整来回震动的四分之一周期
		let curAngle = 0
		let direction = 1
		const timer = setInterval(function(){
			if (direction > 0) {
			curAngle++
			if (curAngle === maxAngle) {
				direction = -1
			}
			} else {
			curAngle--
			if (curAngle === -maxAngle) {
				direction = 1
			}
			}
			el.style.transform = 'rotate(' + curAngle + 'deg)';
		}, interval)
		var that = this;
		setTimeout(function(){
			clearInterval(timer);
			if (!that.haveDataSource) {
				that.elShaking(el);
			}
		}, maxAngle * interval * quarterCycle + 500);
	},
	gameArrowClick(direction) {//游戏界面左右按钮按钮点击
		if (this.onNetworking) {
			return;
		}
		if (direction == 1) {//点击左边按钮往左移动
			if (this.gameItemChooseIndex < 1) {
				this.gameItemChooseIndex = this.gameImgs.length;
			} else{
				this.gameItemChooseIndex -= 1;
			}
		} else{//点击右边按钮往右移动
			if (this.gameItemChooseIndex > this.gameImgs.length-1) {
				this.gameItemChooseIndex = 1;
			} else{
				this.gameItemChooseIndex += 1;
			}
			
		}
		
	},
	cardItemSelect(index) {
		this.gameItemChooseIndex = index+1;
	},
	showPrizePage(result,item) {
		if (!result && !item.name) {
			return;
		}
		this.selectStar = item;
		this.winning = result;
		this.showCollectBox = false;
		this.isFromCollect = true;
		this.showResultBox = true;
	},
	closeToast() {
		this.showToast = false,
		this.receiveSuccess = false,
		this.received = false
	},
	clickMyCollect() {//首页我的福卡集按钮点击
		var _this = this;
		if (!this.isApp) {
			this.showDownLoadPop = true;
			return;
		}
		if (!this.userinfo.token) {
			COVER.getUser((res) => {
				COVERAPP.Method.GetUser({
					callback(res) {
						var user = JSON.parse(res);
						user.origin = 'app';
						_this.setUserinfo(user);
						_this.getLotteryCount('open');
						_this.getPrizeList();
					}
				});
			})
			return;
		}
		this.showBeginBox = false;
		this.showCollectBox = true;

	},
	collectBackBtnclick() {//我的福卡集返回按钮点击
		this.showCollectBox = false;
		this.showBeginBox = true;
	},
	shareInPageBackBtnClick() {
		this.showShareInBox = false;
		this.showCollectBox = true;
	},
	clickBeginGameBtn() {//首页开始抽盲盒按钮点
		var _this = this;
		if (!this.isApp) {
			this.showDownLoadPop = true;
			return;
		}
		if (!this.userinfo.token) {
			COVER.getUser((res) => {
				COVERAPP.Method.GetUser({
					callback(res) {
						var user = JSON.parse(res);
						user.origin = 'app';
						_this.setUserinfo(user);
						_this.getLotteryCount('open');
						_this.getPrizeList();
					}
				});
			})
			return;
		}
		this.showBeginBox = false;
		this.showGameBox = true;
	},
	gamePageBackBtnClick() {//游戏页面点击返回
		
		this.showGameBox = false;
		this.showBeginBox = true;
	},
	clickGameBeginBtn(e) {//开始抽奖按钮点击
		if (this.onNetworking) {
			return;
		}
		if (this.gameTotalCount == 0) {
			var str = "今日抽奖次数已用完,明日继续吧~";
			
			// if (!localStorage.getItem('shareRequested')) {
			// 	str = '今日抽奖次数已用完，分享可获得一次~';
			// }
			this.Toast({
			  text: str,
			});
			return;
		}
		var params = {
			aid: this.aid,
			userinfo: this.userinfo,
		}
		var starTypeNum = 0;
		if (this.collectStarType.length > 0) {
			if (this.collectStarType.length === 1) {
				params['info'] = {starType:this.collectStarType[0]};
				starTypeNum = this.collectStarType[0];
			} else {
				var selectNum = this.collectStarType[this.randomNum(0,this.collectStarType.length-1)]
				params['info'] = {starType: selectNum}
				starTypeNum = selectNum;
			}
		}
		params['origin'] = this.luckOrigin;
		this.elShaking(document.getElementById("shakingImg"));
		var that = this;
		COVER.post('/lottery/luck',params).then(res => {
			var errno = Number(res.errno) 
			if (starTypeNum != 0 && errno !== 0) {
				this.selectStar = this.starInfo[starTypeNum-1]
			}
			if (errno === 0) {
				if (res.data) {
					this.prizeInfo = res.data
				}
			}
			that.gameTotalCount -= 1;
			sessionStorage.setItem('gameCount',that.gameTotalCount);
			if (this.luckOrigin === 'share') {
				// localStorage.setItem('shareRequested', true);
			}
			if (errno === 0 || errno === 2001 || errno === 2003 || errno === 2004 || errno === 2039) {
				that.haveDataSource = true;
				that.onNetworking = false;
				that.showGameBox = false;
				that.winning = errno == 0;
				that.isFromCollect = false;
				that.showResultBox = true;
				that.getPrizeList();
			} else {
				that.haveDataSource = true;
				that.onNetworking = false;
				this.Toast({
					text: "对不起未中奖",
				});
			}
		})
		this.onNetworking = true;
	},
	resultPageBackBtnClick() {//结果页面按钮点击
		let myAudio = document.querySelector("#blessingAudio");
		let bgmAudio = document.querySelector("#bgAudio");
		if (myAudio) {
			if (!sessionStorage.getItem('bgmPause')) {
				bgmAudio.play();
			}
			myAudio.pause();
		}
		this.winning = false;
		this.showResultBox = false;
		if (this.isFromCollect) {
			this.showCollectBox = true;
		} else{
			this.showGameBox = true;
		}
		
	},
	clickPlayAgainBtn() {//未中奖重来一次按钮点击
		let myAudio = document.querySelector("#blessingAudio");
		let bgmAudio = document.querySelector("#bgAudio");
		if (myAudio) {
			if (!sessionStorage.getItem('bgmPause')) {
				bgmAudio.play();
			}
			myAudio.pause();
		}
		this.winning = false;
		this.showResultBox = false;
		this.haveDataSource = false;
		this.showGameBox = true;
		
	},
	clickBlessBtn() {//播放祝福按钮点击
		var audioName = 'https://yunyingcdn.thecover.cn/o_1eu2hlui51gitkhi1d6hdun9s8l.mp3';
		if (this.selectStar && this.selectStar.audio) {
			audioName = this.selectStar.audio
		}
		this.audioSrc = audioName;
		let bgmAudio = document.querySelector("#bgAudio");
		let myAudio = document.querySelector("#blessingAudio");
		if (myAudio) {
			myAudio.volume = 1.0
			myAudio.play();
			myAudio.addEventListener('playing', function () {
				bgmAudio.pause();
			});
			myAudio.addEventListener('ended', function () {
				bgmAudio.play();
		　　});
		}
		
	},
	clickShareBtn() {//分享按钮点击
	
		var shareInfo = JSON.parse(JSON.stringify(this.shareData));
		shareInfo.link = shareInfo.link + '?starType=' + this.selectStar.starType;
		shareInfo.origin = 'None';
		shareInfo.callback = (ret) => {
			COVER.track(this.aid, 'share', '分享');
			const data = typeof ret == 'string'.toLowerCase() ? JSON.parse(ret) : ret;
			if (data.status == 'success' || data.status == '1') {
				this.getLotteryCount('share');
				// localStorage.setItem('shareRequested', true);
			} 
		}
		COVERAPP.Method.Share(shareInfo);
	},
	clickPosterBtn() {//生成海报按钮点击
		this.showPosterBox = true;
		this.drawPoster();
	},
	dateTime(rowData){
		var d = new Date(rowData)
		var a= d.getFullYear() + '-' + (d.getMonth() + 1 < 10 ? "0" + (d.getMonth() + 1) : d.getMonth() + 1) + '-' + (d.getDate()<10 ? "0" +d.getDate():d.getDate())+ ' ' + (d.getHours()<10 ?"0"+d.getDate():d.getDate()) + ':' + (d.getMinutes()<10 ? "0" + d.getMinutes(): d.getMinutes()) + ':' + (d.getSeconds()<10 ? "0" + d.getSeconds() : d.getSeconds() );
		return a
	},
	clickreceiveRewardBtn() {//领取奖品按钮点击
		// this.showToast = true;
		COVER.get('/apply/token',{
			aid:'60224534388cf4003f940981',//报名id
			token: this.userinfo.token
		}).then(res=>{
			
			if (Number(res.errno) === 0 ) {
				if (!res.data) {
					//没有填写过个人信息
					this.showToast = true;
					this.received = false;
					this.receiveSuccess = false;
				} else{
					//填写过个人信息
					var data = res.data;
					data.applyTime = this.dateTime(data.applyTime);
					this.applyInfo = data;
					this.showToast = true;
					this.received = true;
					this.receiveSuccess = false;
				}
			}
		})
		
	},
	submitUserinfo() {
		
		let formData = new FormData();
		for(var key in this.formMess){
			formData.append(key,this.formMess[key]);
		}
		if (this.formData.phone.length == 0) {
			this.Toast({
			  text: "请填写姓名！",
			});
			return;
		}
		if (this.formData.phone.length != 11) {
			this.Toast({
			  text: "请填写11位手机号！",
			});
			return;
		}
		if (this.formData.address.length == 0) {
			this.Toast({
			  text: "请填写邮寄地址！",
			});
			return;
		}
		
		var that = this;
		COVER.post('/apply',{
			aid: '60224534388cf4003f940981',
			token: '60224534388cf4003f940981' + '_' + this.userinfo.token + '_' + 0,
			userinfo: this.userinfo,
			info: {
				...this.formData,
				prize: this.prizeInfo.name,
				code: this.prizeInfo.pid
			},
		}).then(res => {
			if (Number(res.errno) === 0) {
				that.receiveSuccess = true;
			}
		})
	},
	dismissPosterMask() {
		this.showPosterBox = false;
	},
	shareInBeginClick() {
		if (!this.isApp) {
			this.showDownLoadPop = true;
			return;
		}
	},
	/*以下为生成分享图*/
	drawPoster(){
		let canvas = document.createElement('canvas');
		canvas.width = 900;
		canvas.height = 1300;
		let ctx = canvas.getContext('2d');
		var posterImgs = [];
		if (this.selectStar && this.selectStar.image) {
			posterImgs.push(this.defPreImage(require('../assets/images/starPoster/poster/'+this.selectStar.image+'.jpg')))
		} else {
			posterImgs.push(this.defPreImage(require('../assets/images/starPoster/poster/xf.jpg')))
		}
		posterImgs.push(this.defPreImage(require('../assets/images/qrcode.png')))
		var that = this;
		Promise.all(posterImgs).then((imgs) => {
			ctx.drawImage(imgs[0], 0, 0, imgs[0].width, imgs[0].height, 0, 0, imgs[0].width, imgs[0].height);
			ctx.drawImage(imgs[1], 0, 0, imgs[1].width, imgs[1].height, 625, 1045, imgs[1].width, imgs[1].height)
			this.posterImg = canvas.toDataURL("image/jpeg")
		})
		
	},
	//加载图片
	defPreImage(imgPath) {
	    return new Promise((resolve, reject) =>{
	        let img = new Image()
	        img.onload = function () { 
	            resolve(img);  
	        } 
	        img.crossOrigin = 'Anonymous';
	        img.src = imgPath;
	    })
	},
	posterImgClick(e) {
		COVERAPP.Method.shareImage({
			image: e.target.src.split(';base64,')[1],
			title: '新春封面 牛你过年|盲盒送祝福 温情暖新元',
			desc: '嗨皮牛耶，扭转乾坤！点击扭盲盒，收获封面新年祝福官的新年语音祝福和惊喜礼品吧！',
			link: window.location.href,
			imgUrl: 'https://wapcdn.thecover.cn/wap/1.0.0/img/favicon114.png',
			callback(status,origin) {
				if (status == 'success' || status == '1') {
					this.getLotteryCount('share');
					// localStorage.setItem('shareRequested', true);
				}
			}
		})
	}
  },
};
</script>

<!-- <style lang="less" scoped></style> -->
<style lang="less" scoped>

.activity-download-pop {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  z-index: 900;
  .activity-download-pop-inner {
    position: absolute;
    transform: translate(-50%, -50%);
    left: 50%;
    top: 50%;
    width: 6.5rem;
    padding: 0.5rem;
    background-color: #fff;
    border-radius: 0.2rem;
    box-sizing: border-box;
    font-size: 0.45rem;
    text-align: center;
    p {
      color: #474747;
      line-height: 1.3;
    }
    span {
      display: inline-block;
      min-width: 3.3rem;
      text-align: center;
      color: #fff;
      line-height: 1rem;
      padding: 0 0.3rem;
      background-color: #e62f17;
      margin: 0.3rem 0 0.1rem;
      border-radius: 0.2rem;
      letter-spacing: 0.1rem;
      box-sizing: border-box;
      cursor: pointer;
    }
  }
}

</style>